import { useEffect, useState, useRef, useContext } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";

import { cookie } from 'shared-kernel/helpers';

import { LayoutContext } from "../layout/";

import Loader from "../loader";
import { getEndpoint } from "../helper";

function useAutoHide(delay = 1000) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!visible) return;

        const timer = setTimeout(() => setVisible(false), delay);
        return () => clearTimeout(timer);
    }, [visible, delay]);

    return [visible, () => setVisible(true)];
}

export default function Cart(props) {
    const { setPageTitle } = useContext(LayoutContext);

    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [quantityMap, setQuantityMap] = useState({});
    const [focusedCartId, setFocusedCartId] = useState(null);
    const cartIdRef = useRef(cookie.get('cid'));

    const [showToast, triggerToast] = useAutoHide(1500);

    const { id } = useParams();

    const formatNumber = n => n && n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    const fetchData = async () => {
        try {
            let json = null;
            let jsonData = [];
            if (cartIdRef.current) {
                const response = await fetch(getEndpoint(`/api/android/product/getcart?cartid=${cartIdRef.current}`));
                json = await response.json();
            }

            if (json) jsonData = json.data;

            const data = {
                items: jsonData,
                totalPrice: 0,
                totalDiscount: 0,
                payablePrice: 0,
                totalQuantity: 0
            }

            for (const item of jsonData) {
                data.totalPrice += (item.oldPrice * item.quantity);
                data.payablePrice += (item.price * item.quantity);
                data.totalQuantity += item.quantity;
            }

            data.totalDiscount = data.totalPrice - data.payablePrice;

            setData(data);

            setLoading(false);

        } catch (err) {
            if (err.name !== "AbortError") setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = cartId => {
        fetch(getEndpoint(`/api/cart/delete?id=${cartId}`)).then(res => fetchData());
        //triggerToast();
    }

    const handleUpdate = (cartId, prevQuantity, mode) => {
        const q = mode === '+' ? prevQuantity + 1 : Math.max(1, prevQuantity - 1);

        fetch(getEndpoint(`/api/cart/update?id=${cartId}&quantity=${q}`)).then(res => fetchData());
        //triggerToast();
    }

    const ProductBox = ({ cartId, customProductId, productId, brandTitle, productTitle, composition, price, oldPrice, discount, quantity, picture, focused, setFocusedCartId }) => {
        const [localQty, setLocalQty] = useState(quantity);
        const timeoutRef = useRef(null);
        const inputRef = useRef(null);

        useEffect(() => {
            setLocalQty(quantity);
        }, [quantity]);

        useEffect(() => {
            if (focused && inputRef.current) {
                inputRef.current.focus();
            }
        }, [focused]);

        const handleFocus = () => setFocusedCartId(cartId);

        const handleChange = (e) => {
            let value = e.target.value;

            setLocalQty(value);

            if (timeoutRef.current) clearTimeout(timeoutRef.current);

            if (value === '') return;
            if (+value < 1) value = 1;

            timeoutRef.current = setTimeout(() => {
                const numericValue = Number(value);
                setQuantityMap(prev => ({
                    ...prev,
                    [cartId]: numericValue
                }));

                setLoading(true);
                fetch(getEndpoint(`/api/cart/update?id=${cartId}&quantity=${numericValue}`))
                    .then(() => fetchData())
                    .catch(err => console.error(err));
            }, 1000);
        };

        const handleBlur = () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        };

        const Img = () => {
            if (picture && picture.length > 0) return <img src={getEndpoint(`/uploads/shop/product-file/${picture}`)} />;

            return <img src={getEndpoint('/pwa/img/no_pic_750x750.jpg')} />;
        }

        return (
            <div className='box p-r d-f bc-w bw-1 bc--n3 br-3 mb-4'>
                <div className='fsh-0 fg-0' style={{ backgroundColor: '#dddddd', width: '28%' }}>
                    <Img />
                </div>
                <div className='px-2' style={{ width: '82%' }}>
                    <div className='p-r' style={{ top: '.2rem' }}>
                        <div className='lh-2' style={{ height: '3.2rem', width: '90%' }}>{productTitle}</div>
                        <div className='p-r' style={{ height: '1.4rem', fontSize: '.75em', color: '#777777', height: '1.8rem' }}>{brandTitle}</div>
                    </div>
                    <div className='d-f ai-c'>
                        <div className='d-f ai-c jc-c _bc-g-d c-w br-4' style={{ padding: '.2rem .4rem' }}>
                            <div className='d-l fs-4'>{discount}%</div>
                        </div>
                        <div className='mr-2 fw-600' style={{ height: '4.1rem' }}>
                            <div className='d-f ai-c'>
                                <div className='fs-3' style={{ color: '#9c9c9c', textDecorationLine: 'line-through' }}>{formatNumber(oldPrice)}</div>
                                &nbsp;
                                <div style={{ color: '#9c9c9c', fontSize: '.8em' }}>ریال</div>
                            </div>
                            <div className='d-f ai-c p-r _c-b_b' style={{ top: '-.6em' }}>
                                <div className='fs-3' style={{}}>{formatNumber(price)}</div>
                                &nbsp;
                                <div style={{ fontSize: '.8em' }}>ریال</div></div>
                        </div>
                        <div style={{ borderColor: '#acacac', width: '40%' }} className='mr-a fs-3 bw-1 br-3 d-f ai-c'>
                            <svg className='d-b fsh-0 fg-0' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" onClick={e => handleUpdate(cartId, quantity, '+')}>
                                <path fill='#075e54' d="M25.313 15.781h-8v8h-2.625v-8h-8v-2.625h8v-8h2.625v8h8v2.625z"></path>
                            </svg>
                            <input
                                ref={inputRef}
                                className='ta-c bc-t w-100'
                                type="number"
                                value={localQty}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                onFocus={handleFocus}
                            />
                            <svg className='d-b fsh-0 fg-0 mr-a' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" onClick={e => handleUpdate(cartId, quantity, '-')}>
                                <path fill='#075e54' d="M25.313 15.781h-18.625v-2.625h18.625v2.625z"></path>
                            </svg>
                        </div>
                    </div>
                </div>

                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" className='p-a l-1 t-1' onClick={e => handleDelete(cartId)}>
                    <path fill='#ff0000' d="M25.313 7.031l-7.438 7.438 7.438 7.438-1.875 1.875-7.438-7.438-7.438 7.438-1.875-1.875 7.438-7.438-7.438-7.438 1.875-1.875 7.438 7.438 7.438-7.438z"></path>
                </svg>
            </div>
        );
    }

    useEffect(() => {
        setPageTitle('سبد خرید');

        setLoading(true);
        fetchData();
    }, []);

    if (loading) return <Loader />;
    if (error) return <p>Error: {error}</p>;

    if (data.items.length === 0) {
        return (
            <div className='d-f ai-c jc-c h-100vh' style={{ backgroundColor: '#f5f5f5' }}>
                <div style={{ marginTop: '-5rem' }}>
                    <img className='w-9 mx-a mb-4' src={getEndpoint("/pwa/img/empty_cart.png")} />
                    <div>سبد خرید شما خالی است!</div>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className='p-4' style={{ backgroundColor: '#f5f5f5', paddingBottom: '9rem' }}>
                {data.items.map(x => {
                    return (
                        <ProductBox
                            key={x.cartId}
                            cartId={x.cartId}
                            customProductId={x.customProductId}
                            productId={x.productId}
                            brandTitle={x.brandTitle}
                            productTitle={x.productTitle}
                            composition={x.composition}
                            price={x.price}
                            oldPrice={x.oldPrice}
                            discount={x.discount}
                            quantity={x.quantity}
                            picture={x.picture}
                            focused={focusedCartId === x.cartId}
                            setFocusedCartId={setFocusedCartId}
                        />
                    )
                })}

                <div className="d-f mb-2">
                    <div className='_c-95'>مجموع خرید ({data.totalQuantity} کالا):</div>
                    <div className='mr-a _c-95'>{formatNumber(data.totalPrice)} ریال</div>
                </div>
                <div className="d-f mb-2">
                    <div className='_c-95'>مجموع تخفیف</div>
                    <div className='mr-a _c-95'>{formatNumber(data.totalDiscount)} ریال</div>
                </div>
            </div>
            <div className='p-f b-0 l-0 r-0'>
                <div className="d-f ai-c bc-w px-4 fs-3 btw-1" style={{ height: '4rem', borderTopColor: '#ddd' }}>
                    <div className=''>مبلغ قابل پرداخت</div>
                    <div className='mr-a fw-600'>{formatNumber(data.payablePrice)} ریال</div>
                </div>
                <Link to='/checkout' className='d-f ai-c jc-c c-w fs-3 _bc-b' style={{ height: '5rem' }}>ثبت سفارش</Link>
            </div>

            {showToast && (
                <div className='toast p-f b-4 l-0 r-0 d-f jc-c'>
                    <div className='d-if px-5 py-3 br-999' style={{ backgroundColor: '#f0f0f0' }}>
                        سبد خرید بروزرسانی شد!
                    </div>
                </div>
            )}
        </>
    );
}